module.exports = __webpack_public_path__ + "img/lowcode-1.489678b2.png";